import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

import { TrxServicesCardPageRoutingModule } from './trxservices-card-routing.module';

import { TrxServicesCardPage } from './trxservices-card.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { CustomInputModule } from 'src/app/master/common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TrxServicesCardPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    CustomInputModule,
    TranslateModule
  ],
  declarations: [TrxServicesCardPage],
})
export class TrxServicesCardPageModule {}
